<template>
  <form @submit.prevent="update" novalidate autocomplete="off">
    <div class="columns">
      <div class="column is-one-fifth">
        <p class="has-text-weight-bold is-size-6 mb-sm">Transactions Notifications</p>
        <p class="has-text-grey is-size-7">
          Subscribe to push notifications to receive real-time alerts related to transaction events.
        </p>
      </div>
      <div class="column">
        <!-- Existing notifications are loaded -->
        <div v-if="!isLoading">
          <!-- Merchant Notifications -->
          <div v-if="context.isSupplier()">
            <div v-for="notification in supplierNotifications" :key="notification.action" class="mb-md">
              <PushNotification
                :notifications="pushNotifications"
                :action="notification.action"
                :title="notification.title"
                :text="notification.text" />
            </div>
          </div>
          <div v-else>
            <div v-for="notification in merchantNotifications" :key="notification.action" class="mb-md">
              <PushNotification
                :notifications="pushNotifications"
                :action="notification.action"
                :title="notification.title"
                :text="notification.text" />
            </div>
          </div>
        </div>
        <!-- Existing notifications are loaded -->
        <div v-else>
          <div v-for="index in 5" :key="index">
            <div class="has-background-white pa-md rounded-lg mb-sm">
              <div class="mb-md">
                <b-skeleton width="25%" :animated="true"></b-skeleton>
                <b-skeleton width="75%" :animated="true"></b-skeleton>
              </div>
              <b-skeleton width="50%" height="30" :animated="true"></b-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import PushNotification from './PushNotification'

export default {
  components: {
    PushNotification
  },
  computed: {
    ...mapGetters(['context']),
    merchantNotifications () {
      const notifications = []
      this.availableNotifications.forEach(notification => {
        if (notification.context.includes('retailer')) {
          notifications.push(notification)
        }
      })
      return notifications
    },
    supplierNotifications () {
      const notifications = []
      this.availableNotifications.forEach(notification => {
        if (notification.context.includes('supplier')) {
          notifications.push(notification)
        }
      })
      return notifications
    }
  },
  data () {
    return {
      errors: {},
      updating: false,
      availableNotifications: [{
        action: 'Connection Memo Saved',
        title: 'Connection Notifications',
        text: 'Subscribe to push notifications to receive real-time alerts related to your connections & connection notes.',
        context: ['supplier']
      }, {
        action: 'Order Created',
        title: 'Order Received',
        text: 'If you want to be notified when a new order is received, the platform will send an email notification to the email address or distribution list specified below:',
        context: ['supplier']
      }, {
        action: 'Order Canceled',
        title: 'Order Canceled',
        text: 'If you want to be notified when a cancellation request is received, the platform will send an email notification to the email address or distribution list specified below:',
        context: ['supplier', 'retailer']
      }, {
        action: 'Order Backorder Date Updated',
        title: 'Order Backordered',
        text: 'If you want to be notified when a supplier marks an order as backordered',
        context: ['retailer']
      }, {
        action: 'Order Ship To Address Updated',
        title: 'Order Ship To Address Updated',
        text: 'If you want to be notified when a ship to address changed request is received, the platform will send an email notification to the email address or distribution list specified below:',
        context: ['supplier']
      }, {
        action: 'Order Memo Created',
        title: 'Message Received',
        text: 'If you want to be notified when a new message is received on one of your orders, the platform will send an email notification to the email address or distribution list specified below:',
        context: ['supplier', 'retailer']
      }, {
        action: 'Order Returned',
        title: 'Return Received',
        text: 'If you want to be notified when a new RMA is created on one of your orders, the platform will send an email notification to the email address or distribution list specified below:',
        context: ['supplier', 'retailer']
      }, {
        action: 'RMA Completed',
        title: 'Return Approved/Rejected',
        text: 'If you want to be notified when one of your RMAs is approved or rejected, the platform will send an email notification to the email address or distribution list specified below:',
        context: ['supplier', 'retailer']
      }]
    }
  },
  methods: {

  },
  mounted () {

  },
  props: {
    pushNotifications: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  }
}
</script>
